// extracted by mini-css-extract-plugin
export default {"wrapper":"counter_wrapper__2KOEB","plus":"counter_plus__Ol2On","minus":"counter_minus__XOOw4"};